// extracted by mini-css-extract-plugin
export default {"why-choose":"whychoose_why-choose__zrG1j","quick-service":"whychoose_quick-service__vGs6l","control-width":"whychoose_control-width__X8heW"};